import api from './api';

// Definir interfaz para planta
export interface Planta {
  id?: number;
  id_cliente: number;
  denominacion: string;  // El campo real en la base de datos
  direccion?: string;
  ciudad?: string;
  activo?: number;
}

// Obtener todas las plantas
export const getPlantas = async (): Promise<Planta[]> => {
  try {
    console.log('Obteniendo todas las plantas desde API');
    const response = await api.get('/plantas');
    return response.data;
  } catch (error) {
    console.error('Error al obtener plantas desde la API:', error);
    // Datos estáticos como respaldo en caso de error
    const PLANTAS_ESTATICAS: Planta[] = [
      { id: 1, id_cliente: 1, denominacion: 'Planta 1', direccion: 'Mitre 5000 Avellaneda' },
      { id: 2, id_cliente: 2, denominacion: 'Planta 2', direccion: 'Mitre 5000 Avellaneda' },
      { id: 3, id_cliente: 2, denominacion: 'Planta 3', direccion: 'Mitre 5000 Avellaneda' },
      { id: 4, id_cliente: 3, denominacion: 'Estación de servicio', direccion: 'J. B. Alberdi 2299, CABA' },
      { id: 5, id_cliente: 1, denominacion: 'Planta Norte', direccion: 'Corrientes 2500, CABA' },
      { id: 6, id_cliente: 3, denominacion: 'Planta Central', direccion: 'Av. de Mayo 800, CABA' },
      { id: 7, id_cliente: 4, denominacion: 'Planta Industrial', direccion: 'Camino de Cintura 2000, La Matanza' }
    ];
    console.warn('Usando datos estáticos de respaldo');
    return PLANTAS_ESTATICAS;
  }
};

// Obtener plantas por ID de cliente
export const getPlantasByClienteId = async (clienteId: number): Promise<Planta[]> => {
  try {
    console.log(`Obteniendo plantas para cliente ID ${clienteId} desde API`);
    const response = await api.get('/plantas', {
      params: { id_cliente: clienteId }
    });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener plantas para cliente ${clienteId}:`, error);
    // Filtrar datos estáticos por id_cliente como respaldo
    const PLANTAS_ESTATICAS: Planta[] = [
      { id: 1, id_cliente: 1, denominacion: 'Planta 1', direccion: 'Mitre 5000 Avellaneda' },
      { id: 2, id_cliente: 2, denominacion: 'Planta 2', direccion: 'Mitre 5000 Avellaneda' },
      { id: 3, id_cliente: 2, denominacion: 'Planta 3', direccion: 'Mitre 5000 Avellaneda' },
      { id: 4, id_cliente: 3, denominacion: 'Estación de servicio', direccion: 'J. B. Alberdi 2299, CABA' },
      { id: 5, id_cliente: 1, denominacion: 'Planta Norte', direccion: 'Corrientes 2500, CABA' },
      { id: 6, id_cliente: 3, denominacion: 'Planta Central', direccion: 'Av. de Mayo 800, CABA' },
      { id: 7, id_cliente: 4, denominacion: 'Planta Industrial', direccion: 'Camino de Cintura 2000, La Matanza' }
    ];
    console.warn('Usando datos estáticos filtrados de respaldo');
    return PLANTAS_ESTATICAS.filter(planta => planta.id_cliente === clienteId);
  }
};

// Obtener una planta por ID
export const getPlantaById = async (id: number): Promise<Planta | null> => {
  try {
    console.log(`Obteniendo planta ID ${id} desde API`);
    const response = await api.get(`/plantas/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error al obtener planta ${id}:`, error);
    return null;
  }
};

// Crear una nueva planta
export const createPlanta = async (planta: Planta): Promise<Planta | null> => {
  try {
    console.log('Creando nueva planta:', planta);
    const response = await api.post('/plantas', planta);
    return response.data;
  } catch (error) {
    console.error('Error al crear planta:', error);
    return null;
  }
};

// Actualizar una planta
export const updatePlanta = async (id: number, planta: Partial<Planta>): Promise<Planta | null> => {
  try {
    console.log(`Actualizando planta ID ${id}:`, planta);
    const response = await api.put(`/plantas/${id}`, planta);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar planta ${id}:`, error);
    return null;
  }
};

// Eliminar una planta
export const deletePlanta = async (id: number): Promise<boolean> => {
  try {
    console.log(`Eliminando planta ID ${id}`);
    await api.delete(`/plantas/${id}`);
    return true;
  } catch (error) {
    console.error(`Error al eliminar planta ${id}:`, error);
    return false;
  }
}; 